'use strict';

var fitvids = require('fitvids');

module.exports = {
    init: function () {
        fitvids('.js-fit-video, .content-panel');
    }
};



// WEBPACK FOOTER //
// ./modules/videoResize.js